export const AUTH_KEY = 'webapp:auth-complete';
export const ONBOARDING_KEY = 'webapp:onboarding-complete';
